import usePrivateAxios from '@/common/api/usePrivateAxios'
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant'
import { Mapper } from '@/common/services/mapper'
import { MetaResponse } from '@/common/types/metaResponse'
import { keepPreviousData, useQuery } from '@tanstack/react-query'

type UseMaintenanceWorkflowsProps<T> = {
  filters?: {
    search?: string;
    page?: number;
    companyId?: string;
    status?: string;
    equipmentId?: string;
    branchId?: string;
    currentForwardingStatus?: string
  };
  mapper?: (data: any) => T;
  enabled?: boolean;
}

export const useMaintenanceWorkflows = <T,>({
  filters: { search = '', page = 1, companyId, status, equipmentId, branchId, currentForwardingStatus } = {},
  mapper = Mapper.default<T>(),
  enabled,
}: UseMaintenanceWorkflowsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { data: { data, meta } = defaultTransformerResponse<T>(), ...rest } = useQuery({
    queryKey: ['maintenanceWorkflows', companyId, search, page, status, equipmentId, branchId, currentForwardingStatus],
    queryFn: () => {
      return privateAxios.get(`/maintenance/workflows`, {
        params: {
          search,
          page,
          'q[company_id_eq]': companyId,
          'q[status_eq]': status,
          'q[equipment_id_eq]': equipmentId,
          'q[branch_id_eq]': branchId,
          'q[current_forwarding_status_eq]': currentForwardingStatus
        },
      })
    },
    select: (data: { data: { data: any[]; meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
    enabled: typeof enabled === 'boolean' ? enabled : true,
  });

  return { data, meta, ...rest }
}
